import { render, staticRenderFns } from "./HumanBackComponent.vue?vue&type=template&id=71fec016&scoped=true&"
import script from "./HumanBackComponent.vue?vue&type=script&lang=js&"
export * from "./HumanBackComponent.vue?vue&type=script&lang=js&"
import style0 from "./HumanBackComponent.vue?vue&type=style&index=0&id=71fec016&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fec016",
  null
  
)

export default component.exports